export default function() {
  
  const widgetName = 'fairgroundsSwiper';
  const widgetOpts = fairgroundsSwiperOpts;

  const swiperContainers = `
    <div class="swiper-container-images">
      <div class="swiper-wrapper"></div>
    </div>

    <div class="swiper-container swiper-container-content">
      <div class="swiper-wrapper"></div>
    </div>
  `;


  // Slide Templates
  function buildSlideTemplateImages(slide) {

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }
  
  function buildSlideTemplateContent(slide) {

    const title = `<h2>${slide.Title}</h2>`;

    const buttons = function(btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');

        if (!btn2) {
          btn2 = btn1;
        }        

        btnContainer.append(`<a href="${btn2}" class="button buyNowButton">MORE</a>`);
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    }

    const template = `
      <div class="swiper-slide">
        <div class="swiper-content-wrapper">
          <div class="swiper-content">
            <div class="swiper-button swiper-button-prev"></div>
            ${title}
            ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
            <div class="swiper-button swiper-button-next"></div>
          </div>
        </div>
      </div>
    `;

    return template;
  }


  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(`#${widgetName} .swiper-container-content .swiper-wrapper`);
    
    widgetData.forEach(function(slide, i) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: 10000,
      },
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: true,     
      loop: true,
      effect: 'cards',
    }); 

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      autoplay: {
        delay: 10000,
      },
      spaceBetween: 0,
      centeredSlides: false,
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });

    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

  }

  
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function(response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).addClass('swiper-widget').html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
      $('.homepage .tier-two').addClass('swiper-hidden');
    }
  });

}
